const hasWindow = ()=>window !== undefined;
export default hasWindow;
